import script from "./add-team-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./add-team-dialog.vue?vue&type=script&setup=true&lang=js"

import "./add-team-dialog.vue?vue&type=style&index=0&id=66943724&lang=scss&scoped=true"
import "./add-team-dialog.vue?vue&type=style&index=1&id=66943724&lang=scss"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66943724"]])

export default __exports__